import * as React from 'react'
import { SVGProps } from 'react'
const SvgStarHalfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.997 0H16v.006a2.092 2.092 0 0 1 1.862 1.138l-.89.456.893-.45 4.214 8.348 8.033.796a2.074 2.074 0 0 1 1.279 3.537l-6.652 6.593 2.467 8.962a2.084 2.084 0 0 1-2.947 2.398l-.003-.001L16 27.695l-8.244 4.082-.003.002a2.084 2.084 0 0 1-2.918-1.224 2.084 2.084 0 0 1-.032-1.18l.002-.008 2.464-8.951-6.653-6.59a2.073 2.073 0 0 1-.566-1.024 2.073 2.073 0 0 1 1.842-2.52l8.033-.795 4.21-8.348A2.092 2.092 0 0 1 15.997 0ZM16 25.579a1 1 0 0 1 .444.104l8.71 4.313a.084.084 0 0 0 .12-.095l-2.618-9.51a1 1 0 0 1 .26-.976l7.067-7.004a.073.073 0 0 0-.046-.125l-.016-.002-8.586-.85a1 1 0 0 1-.794-.545l-4.46-8.833v-.001a.092.092 0 0 0-.081-.05V25.58Z'
      fill={props.color ?? '#CC3E76'}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.997 0H16v.006a2.092 2.092 0 0 1 1.862 1.138l-.89.456.893-.45 4.214 8.348 8.033.796a2.074 2.074 0 0 1 1.279 3.537l-6.652 6.593 2.467 8.962a2.084 2.084 0 0 1-2.947 2.398l-.003-.001L16 27.695l-8.244 4.082-.003.002a2.084 2.084 0 0 1-2.918-1.224 2.084 2.084 0 0 1-.032-1.18l.002-.008 2.464-8.951-6.653-6.59a2.073 2.073 0 0 1-.566-1.024 2.073 2.073 0 0 1 1.842-2.52l8.033-.795 4.21-8.348A2.092 2.092 0 0 1 15.997 0ZM16 25.579a1 1 0 0 1 .444.104l8.71 4.313a.084.084 0 0 0 .12-.095l-2.618-9.51a1 1 0 0 1 .26-.976l7.067-7.004a.073.073 0 0 0-.046-.125l-.016-.002-8.586-.85a1 1 0 0 1-.794-.545l-4.46-8.833v-.001a.092.092 0 0 0-.081-.05V25.58Z'
      fill='url(#star_half_icon_svg__a)'
      fillOpacity={0.25}
    />
    <defs>
      <linearGradient
        id='star_half_icon_svg__a'
        x1={16.002}
        y1={0}
        x2={16.002}
        y2={32.005}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgStarHalfIcon
